import { render, staticRenderFns } from "./RightBanner.vue?vue&type=template&id=01cb237d&"
import script from "./RightBanner.vue?vue&type=script&lang=js&"
export * from "./RightBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01cb237d')) {
      api.createRecord('01cb237d', component.options)
    } else {
      api.reload('01cb237d', component.options)
    }
    module.hot.accept("./RightBanner.vue?vue&type=template&id=01cb237d&", function () {
      api.rerender('01cb237d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/components/RightBanner.vue"
export default component.exports